
import React, { useEffect, useState } from "react";
import ActionButton from "../../components/ActionButton";
import { Link } from "react-router-dom";
import { FiEdit } from "react-icons/fi";
import DashboardLayout from "../../components/DashboardLayout";
import DashboardCard from "../../components/DashboardCard";
import { LIGHT_BLUE_COLOR } from "../../constants";
import { MdOutlineArrowBackIosNew } from "react-icons/md";
import { useForm } from "react-hook-form";
import ShowErrorAlert from "../../components/ErrorAlert";
import { extractErrorMessage } from "../../utils";
import axios from "axios";
import { BASE_URL } from "../../constants";
import { useSelector } from "react-redux";
import { ClipLoader } from "react-spinners";
import DashboardHeading from "../../components/DashboardHeading";
import Label from "../../components/Label";
import CustomInput from "../../components/CustomInput";
import { ADD_LOCATION_FIELDS } from "./Config.constant";
import ConfigurationsHeader from "./ConfigurationsHeader";
import CustomSelect from "../../components/CustomSelect";

const AddZone = () => {
    const {
        handleSubmit,
        formState: { errors },
        getValues,
        control,
        watch,
        setValue,
        reset
    } = useForm({
        values: {
            name: "",
        },
    });

    // Redux Store
    const {
        auth: {
            token,
            user: { _id: userId },
        },
    } = useSelector((state) => state);

    // State Variables
    const [loading, setLoading] = useState(false);
    const [locations, setLocations] = useState(null);
    const [locationId, setLocationId] = useState(null);

    async function addLocationReq(body) {
        setLoading(true);
        try {
            await axios.post(`${BASE_URL}/users/${userId}/locations/${locationId}/zones`, body, {
                headers: {
                    Authorization: token,
                },
            });
            setLoading(false);
            reset();
        } catch (err) {
            setLoading(false);
            console.log(err);
            ShowErrorAlert(extractErrorMessage(err));
        }
    }

    async function getLocations(body) {
        setLoading(true);
        try {
            const {
                data: { locations },
            } = await axios.get(`${BASE_URL}/users/${userId}/locations`, {
                headers: {
                    Authorization: token,
                },
            });
            const locationObj = prepareLocationObj(locations);
            setLocations(locationObj);
            reset({ name: locations[0].name });
            setLocationId(locations[0]._id);
            setLoading(false);
        } catch (err) {
            setLoading(false);
            console.log(err);
            ShowErrorAlert(extractErrorMessage(err));
        }
    }

    const prepareLocationObj = (location) => {
        for (let [key, value] of location.entries()) {
            let selected = false;
            if (!key) selected = true;
            location[key] = { _id: value._id, name: value.name, label: value.name, value: value._id, selected }
        }
        return location;
    }

    function onChangeLocation(e) {
        const selectedIndex = e.target.selectedIndex;

        setLocationId(locations[selectedIndex]._id);
        // let updatedServiceType = [...serviceTypes];
        // for (let [index, serviceType] of updatedServiceType.entries()) {
        //     if (index !== selectedIndex) {
        //         serviceType.selected = false;
        //     } else {
        //         serviceType.selected = true;
        //     }
        // }
        // setServiceTypes(updatedServiceType);
        // reset({type: serviceTypes[selectedIndex].label, amount: serviceTypes[selectedIndex].amount})
    }

    function onSubmit(data) {
        addLocationReq(data);
    }

    useEffect(() => {
        getLocations();
    }, []);

    return (
        <DashboardLayout >
            <ConfigurationsHeader />
            <DashboardCard backgroundColor={LIGHT_BLUE_COLOR}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="flex justify-between align-center">
                        <div className="flex align-center">
                            <Link to="/admins/configurations/zones">
                                <MdOutlineArrowBackIosNew size={20} />
                            </Link>
                            <DashboardHeading>Add Zone</DashboardHeading>
                        </div>
                        <ActionButton type="submit" disabled={loading}>
                            {loading ? <ClipLoader color="black" size={20} /> : "Add"}
                        </ActionButton>
                    </div>
                    {/* form starts here */}
                    <DashboardCard>
                        <div key="location" className="mt-3">
                            <Label required="true">Location</Label>
                            <CustomSelect
                                name={"location"}
                                control={control}
                                errors={errors}
                                errorText={"Service Type is required"}
                                options={locations ? locations : []}
                                onHandleChange={onChangeLocation}
                            />
                        </div>
                        {ADD_LOCATION_FIELDS(getValues).map(
                            ({ name, required, label, type, rules, errorText }) => (
                                <div key={name} className="mt-3">
                                    <Label required={required}>{label}</Label>
                                    <CustomInput
                                        name={name}
                                        type={type}
                                        control={control}
                                        rules={rules}
                                        errors={errors}
                                        errorText={errorText}
                                    />
                                </div>
                            )
                        )}
                    </DashboardCard>
                </form>
            </DashboardCard>
            {/* <DashboardCard backgroundColor={LIGHT_BLUE_COLOR}>
                <div style={{ display: "flex", flexDirection: "row" }}>
                    <span style={{ fontSize: "32px" }}>OR</span>
                    <Link style={{ width: "fit-content", marginLeft: "24px" }} to="/admins/configurations/addLocation"  >
                        <ActionButton style={{ height: "55px" }} className={"flex-shrink-1"}>
                            <FiEdit color="white" size={20} className="me-2" />
                            <small>Add Location</small>
                        </ActionButton></Link>
                    <Link style={{ width: "fit-content", marginLeft: "24px" }} to="/admins/configurations/updateLocation"  >
                        <ActionButton style={{ height: "55px" }} className={"flex-shrink-1"}>
                            <FiEdit color="white" size={20} className="me-2" />
                            <small>Update Location</small>
                        </ActionButton></Link>
                    <Link style={{ width: "fit-content", marginLeft: "24px" }} to="/admins/configurations/zones"  >
                    <ActionButton style={{ height: "55px" }} className={"flex-shrink-1"}>
                        <FiEdit color="white" size={20} className="me-2" />
                        <small>All Zones</small>
                    </ActionButton></Link>
                    <Link style={{ width: "fit-content", marginLeft: "24px" }} to="/admins/configurations/updateZone"  >
                        <ActionButton style={{ height: "55px" }} className={"flex-shrink-1"}>
                            <FiEdit color="white" size={20} className="me-2" />
                            <small>Update Zones</small>
                        </ActionButton></Link>
                </div>
            </DashboardCard> */}
        </DashboardLayout>

    )
}

export default AddZone;